<template>
    <div class="right-content">
        <template v-if="isShowPonit">
            <!-- 基本信息 -->
            <BaseList :carrierDetail="carrierDetail" />
            <div class="r-c-bottom">
                <!-- 列表 -->
                <DeviceList :sensordata="sensordata" @viewSensor="viewSensor" :carrierInfo="carrierDetail" />
                <!-- 历史预览区 -->
                <HistoryView v-if="isView" v-bind="$attrs" :sensorObj="sensorObj" :defaultTabs="defaultTabs"
                    :carrierInfo="carrierDetail" ref="his" />
                <p v-else>{{ $t('integration.please_select_a_preview_device') }}</p>
            </div>
        </template>
        <p v-else>{{ $t('integration.please_select_the_preview_monitoring_point') }}</p>
    </div>
</template>

<script>
import bus from "@/utils/bus";
import { detaiIds } from '@/api/modules/dataDetail.js';
import BaseList from './component/BaseList.vue';
import DeviceList from './component/DeviceList.vue';
import HistoryView from './component/HistoryView.vue';
export default {
    components: {
        BaseList,
        DeviceList,
        HistoryView
    },
    data() {
        return {
            isShowPonit: false,
            carrierDetail: {},
            sensordata: [],
            isView: false,
            sensorObj: {},

            defaultTabs: [{ code: '0', content: $t('integration.temperature'), name: 'temp' }]
        }
    },
    mounted() {
        bus.$on('viewCarrierFn', row => {
            this.isShowPonit = true;
            this.isView = false;
            detaiIds(row.id).then(({ result }) => {
                this.carrierDetail = result;
                this.sensordata = result['carrierDevice'].deviceList || [];
                this.sensordata = this.sensordata.filter(item => item.deviceCatalog === 0);
            })
        })

        bus.$on('cancelSelect', id => {
            if (id === this.carrierDetail.id) {
                this.isShowPonit = false;
                this.isView = false
            }
        })

        bus.$on("selectRows", rows => {
            if (rows.length === 0) {
                this.carrierDetail = {};
                this.sensordata = [];
                this.isShowPonit = false
                this.isView = false
                return
            }
            let flag = rows.some(item => item.id === this.carrierDetail.id);
            this.isShowPonit = flag;
            this.isView = flag;
            if (!flag) {
                this.carrierDetail = {};
                this.sensordata = [];
            }
        })

        bus.$on('dataValFn', val => {
            this.defaultTabs = val
        })
    },
    beforeDestroy() {
        bus.$off('viewCarrierFn')
        bus.$off('cancelSelect')
        bus.$off('selectRows')
        bus.$off('changeFileFn')
        bus.$off('dataValFn')
    },
    methods: {
        viewSensor(row) {
            this.isView = true;
            this.$nextTick(() => {
                if (row.probeValue && typeof row.probeValue === 'string') {
                    row.probeValue = JSON.parse(row.probeValue);
                }
                this.sensorObj = { ...row }
            })
            // dataHistory()
        }
    }
}
</script>

<style lang="scss" scoped>
.right-content {
    flex: 1;
    border: 1px solid #ccc;
    border-left: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .r-c-bottom {
        flex: 1;
        display: flex;
    }

    p {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        font-weight: bold;
        color: #cfcfcf;
        margin: 0 auto;
    }
}
</style>